import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { ADMIN_PAGES_KEYS, NS } from '../../i18n/constants/keys';
import { Button } from '../../ui';

export const Unauthorized = () => {
  const history = useHistory();
  const { t } = useTranslation(NS.adminPages);
  const UA = ADMIN_PAGES_KEYS.unauthorized;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        width: '100%',
        px: 2,
      }}
    >
      <Paper
        elevation={0}
        variant='outlined'
        sx={{
          borderRadius: '24px',
          p: { xs: 4, sm: 5 },
          maxWidth: 560,
          width: '100%',
          textAlign: 'center',
          bgcolor: '#ffffff',
          borderColor: 'divider',
          boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.08)',
        }}
      >
        {/* Shield Lock Icon */}
        <Box sx={{ width: 140, height: 140, mx: 'auto', mb: 3 }}>
          <svg
            style={{ width: '100%', height: '100%' }}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <defs>
              <linearGradient
                id='shieldLockGradient'
                x1='0'
                y1='0'
                x2='0'
                y2='24'
                gradientUnits='userSpaceOnUse'
              >
                <stop stopColor='#059669' />
                <stop offset='1' stopColor='#064e3b' />
              </linearGradient>
            </defs>
            <path
              d='M12 2L4 5V11C4 16 7.5 20.5 12 22C16.5 20.5 20 16 20 11V5L12 2Z'
              fill='url(#shieldLockGradient)'
              stroke='#064e3b'
              strokeWidth='1.5'
            />
            <path
              d='M9 11V9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9V11M10.5 14C10.5 13.1716 11.1716 12.5 12 12.5C12.8284 12.5 13.5 13.1716 13.5 14C13.5 14.8284 12.8284 15.5 12 15.5C11.1716 15.5 10.5 14.8284 10.5 14Z'
              stroke='white'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </Box>

        {/* Message */}
        <Typography variant='h5' sx={{ fontWeight: 700, color: 'text.primary', mb: 1, letterSpacing: '-0.02em' }}>
          {t(UA.title)}
        </Typography>
        <Typography variant='body2' sx={{ color: 'text.secondary', mb: 4, lineHeight: 1.6 }}>
          {t(UA.message)}
        </Typography>

        {/* Actions */}
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent='center'>
          <Button
            onClick={() => history.push('/')}
            label={t(UA.goHome)}
            variant='primary'
          />
          <Button
            onClick={() => history.push('/login')}
            label={t(UA.loginAgain)}
            variant='secondary'
          />
        </Stack>
      </Paper>
    </Box>
  );
};

